import { PersonType } from '@/types/api';
import * as Styles from './AddTalentToJob.styles';
import SearchDropdownButton, { Props as SearchDropdownButtonProps } from '../SearchDropdownButton';

export type Props = Pick<
  SearchDropdownButtonProps<PersonType>,
  'className' | 'searchValue' | 'onSearchChange' | 'showInput' | 'onShowInputChange' | 'loading'
> & {
  allTalents: PersonType[];
  onAddTalent?: (personId: string) => void;
};

const AddTalentToJobComponent = ({ allTalents, onAddTalent, ...props }: Props): JSX.Element => {
  return (
    <SearchDropdownButton
      buttonLabel="Add talent"
      itemButtonLabel="Add talent to this job"
      items={allTalents}
      onResultClick={(candidate) => onAddTalent?.(candidate.id)}
      renderItem={(candidate) => <Styles.CandidateCard displaySourceInfo person={candidate} />}
      keyExtractor={(candidate) => candidate.id}
      {...props}
    />
  );
};

export default AddTalentToJobComponent;
